import { Autocomplete, Popper, TextField, Typography, autocompleteClasses } from "@mui/material";
import { styled } from "@mui/styles";
import { forwardRef, useEffect, useImperativeHandle, useRef } from "react";
import { useState } from "react"
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
const StyledPopper = styled(Popper)(({ theme }) => ({
    [`& .${autocompleteClasses.listbox}`]: {
        boxSizing: 'border-box',
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        fontSize: '11px',

        '& li': {
            padding: '3px 8px',
        },
    },
}));


const TextSearchableCellEditor = forwardRef((props, ref) => {
    console.log(":: props", props)
    const [searchList, setSearchList] = useState([]);
    const refInput = useRef();
    const [fieldValue, setFieldValue] = useState(props.value);
    const url = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.voucher}`;
    useEffect(() => {
        if (props.column.colId === 'account') {
            const getlist = async () => {
                try {
                    const list = await OAuthService.getList(url + '/searchSubLedger?name=' + fieldValue)
                    if (list?.data) {
                        setSearchList(list.data)

                    }
                } catch (error) {

                }
            }
            getlist()

        }
    }, [fieldValue]);

    useEffect(() => {
        if (props.column.colId === 'account') {
            const getlist = async () => {
                try {
                    const list = await OAuthService.getList(url + '/searchSubLedger?name=' + fieldValue)
                    if (list?.data) {
                        setSearchList(list.data)

                    }
                } catch (error) {

                }
            }
            getlist()

        }

        window.setTimeout(() => {
            const eInput = refInput.current;
            eInput.focus();
        });

    }, []);

    const handleInputChange = (event, value) => {
        setFieldValue(value)
    }

    useImperativeHandle(ref, () => {

        return {
            getValue: () => {
                const rowNode = props.node;
                if (fieldValue) {
                    rowNode.setDataValue('accountNumber', fieldValue.code || props.node.data.code || props.node.data.accountNumber);
                    rowNode.setDataValue('name', fieldValue.name || props.node.data.name);
                    rowNode.setDataValue('subLegId', fieldValue.id || props.node.data.id);
                    rowNode.setDataValue('headId', fieldValue.headId || props.node.data.headId);
                    rowNode.setDataValue('headName', fieldValue.headName || props.node.data.headName);
                    rowNode.setDataValue('groupId', fieldValue.groupId || props.node.data.groupId);
                    rowNode.setDataValue('groupName', fieldValue.groupName || props.node.data.groupName);
                    rowNode.setDataValue('generalLedgerId', fieldValue.generalLedgerId || props.node.data.generalLedgerId);
                    rowNode.setDataValue('generalLedgerName', fieldValue.generalLedgerName || props.node.data.generalLedgerName);
                    rowNode.setDataValue('ledgerId', fieldValue.ledgerId || props.node.data.ledgerId);
                    rowNode.setDataValue('ledgerName', fieldValue.ledgerName || props.node.data.ledgerName);
                }
                return fieldValue.name ? fieldValue.code + ' ' + fieldValue.name : props.value;
            },
            focusIn() {
                var eInput = refInput.current;
                eInput.focus();
                eInput.select();
            },
        };
    });

    return (
        <>
            <Autocomplete
                disableClearable
                PopperComponent={StyledPopper}
                options={searchList}
                sx={{ fontSize: 'smaller' }}
                value={fieldValue}
                getOptionLabel={(option) => {
                    // Value selected with enter, right from the input
                    if (typeof option === 'string') {
                        return option;
                    }
                    // Add "xxx" option created dynamically
                    if (option.inputValue) {
                        return option.inputValue;
                    }
                    // Regular option
                    return option?.name ? option?.code + ' ' + option?.name : '';
                }}
                onChange={handleInputChange}
                onInputChange={handleInputChange}
                renderOption={(props, option) => <li {...props}>{option.code + ' ' + option.name}</li>}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        inputRef={refInput}
                    // InputProps={{
                    //     ...params.InputProps,
                    //     // type: 'search',
                    // }}
                    // InputLabelProps={{ shrink: true }}
                    />
                )}
            />
        </>
    )
})

export default TextSearchableCellEditor